import React from 'react';
import CancelIcon from '../../../../assets/icons/cancel-icon.svg';

interface CancelButtonDataModel {
  onClick: () => void;
}

const CancelButton: React.FC<CancelButtonDataModel> = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        width: 'min-content',
        border: '1px solid #D1D4E3',
        backgroundColor: '#D1D1D1',
        paddingRight: '10px',
        paddingLeft: '15px',
        paddingTop: '1px',
        paddingBottom: '1px',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <img height={24} src={CancelIcon} />
      <div style={{ color: '#ffffff' }}>ביטול</div>
    </div>
  );
};

export default CancelButton;
